// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1WNQp","label":"Radio_label__22qY2","checkMark":"Radio_checkMark__3zyUW","disabled":"Radio_disabled__fCKTi"};